export const DefaultGracePeriod = 15;
export const MaxGracePeriod = 59;
export const MinIdleGracePeriod = 15;
export const MinNoConnectGracePeriod = 15;
